import { CartItem } from '@/entities/cart/model/cartStore';
import { useRequestStore } from '@/features/requests/requests'

export const cartApi = {
  getRequestStore() {
    return useRequestStore();
  },

  async load(force: boolean = false): Promise<CartItem[]> {
    return await this.getRequestStore().send("me/cart", {
      onlyWithAuth: true,
      noCache: force
    });
  },

  async add(merchId: number, amount: number) {
    return await this.getRequestStore().send("cart", {
      method: "POST",
      onlyWithAuth: true,
      payload: {
        merchId,
        amount
      }
    });
  },

  async update(merchId: number, amount: number) {
    return await this.getRequestStore().send("cart", {
      method: "POST",
      payload: { merchId, amount }
    });
  },

  async remove(cartItemId: number) {
    return await this.getRequestStore().send(`cart/${cartItemId}`, {
      method: "DELETE",
      onlyWithAuth: true,
    });
  },

  async removeMany(merchIds: number[]) {
    return await this.getRequestStore().send(`cart/deleteMany`, {
      method: 'POST',
      onlyWithAuth: true,
      payload: { merchIds }
    });
  }
};
